var actions = {};

import duplicate from "packs/actions/duplicate.js";
actions.duplicate = duplicate;

export default actions;
